// // import * as Sentry from '@sentry/browser'
import * as httpStatusCodes from 'http-status-codes'
import Router from 'next/router'
import { all, call, select, takeLatest, put, delay } from 'redux-saga/effects'
import type { SagaReturnType } from 'redux-saga/effects'

import createJob from '../../../service/job/create-job/createJob'
import submitJobCriteria from '../../../service/job/submit-job-criteria/submitJobCriteria'
import submitJobDescription from '../../../service/job/submit-job-description/submitJobDescription'
import submitJobCompanyInfo from '../../../service/job/submit-job-company-info/submitJobCompanyInfo'
import submitJob from '../../../service/job/submit-job/submitJob'

import * as actionTypes from '../../actions/job/job'
import { showDialog } from '../../actions/ui/ui'

export function* createJobSaga({ product }: actionTypes.JobCreateAction) {
  try {
    const { status, data: id }: SagaReturnType<typeof createJob> = yield call<any>(createJob, product?.product || null)

    if (status === httpStatusCodes.CREATED) {
      yield delay(3000)
      yield call(Router.push, `/vacature/variabel/${id}/criteria`)
    } else {
      yield put(
        showDialog({
          title: 'Er ging iets mis',
          content: 'De vacature editor is momenteel niet bereikbaar. Probeer het later opnieuw.',
        }),
      )
    }
  } catch (error) {
    yield put(
      showDialog({
        title: 'Er ging iets mis',
        content: 'De vacature editor is momenteel niet bereikbaar. Probeer het later opnieuw.',
      }),
    )
    // Sentry.captureException(error)
  }
}

export function* submitJobDataSaga(
  action:
    | actionTypes.JobSubmitCriteriaAction
    | actionTypes.JobSubmitDescriptionAction
    | actionTypes.JobSubmitCompanyInfoAction,
) {
  try {
    let submit: typeof submitJobCriteria | typeof submitJobDescription | typeof submitJobCompanyInfo
    let nextPage: string

    if (action.type === 'job/SUBMIT_CRITERIA') {
      submit = submitJobCriteria
      nextPage = '/vacaturetekst'
    } else if (action.type === 'job/SUBMIT_JOB_DESCRIPTION') {
      submit = submitJobDescription
      nextPage = '/bedrijf'
    } else if (action.type === 'job/SUBMIT_JOB_COMPANY_INFO') {
      submit = submitJobCompanyInfo
      nextPage = '/promotie'
    }

    const { status }: SagaReturnType<typeof submit> = yield call<any>(submit, action.payload)

    if (status === httpStatusCodes.NO_CONTENT) {
      yield call(Router.push, `/vacature/variabel/${action.payload.jobId}${nextPage}`)
    } else {
      throw new Error(`Failed to submit data (${action.type})`)
    }
  } catch (error) {
    yield put(
      showDialog({
        title: 'Er ging iets mis',
        content: 'Opslaan mislukt. Probeer het later opnieuw.',
      }),
    )
    // Sentry.captureException(error)
  }
}

export function* submitJobSaga(action: actionTypes.JobSubmitAction) {
  try {
    const { status }: SagaReturnType<typeof submitJob> = yield call(submitJob, action.payload)

    if (status === httpStatusCodes.NO_CONTENT) {
      yield call(Router.push, `/vacatures`)
    } else {
      throw new Error(`Failed to submit job`)
    }
  } catch (error) {
    yield put(
      showDialog({
        title: 'Er ging iets mis',
        content: 'Opslaan mislukt. Probeer het later opnieuw.',
      }),
    )
    // Sentry.captureException(error)
  }
}

export default function* saga() {
  yield all([
    takeLatest(actionTypes.JOB_CREATE, createJobSaga),
    takeLatest(
      [actionTypes.JOB_SUBMIT_CRITERIA, actionTypes.JOB_SUBMIT_DESCRIPTION, actionTypes.JOB_SUBMIT_COMPANY_INFO],
      submitJobDataSaga,
    ),
    takeLatest(actionTypes.JOB_SUBMIT, submitJobSaga),
  ])
}
